import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, Stack, FormControlLabel, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';

const InlineLinkInput = ({ onInsert, onCancel, initialValues = {} }) => {
    const { t } = useTranslation();
    const [url, setUrl] = useState(initialValues.url || '');
    const [text, setText] = useState(initialValues.text || '');
    const [isButton, setIsButton] = useState(initialValues.isButton || false);

    useEffect(() => {
        setUrl(initialValues.url || '');
        setText(initialValues.text || '');
        setIsButton(initialValues.isButton || false);
    }, [initialValues]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!isValid) return;
        onInsert({ url: url.trim(), text: text.trim(), isButton });
    };

    const isValid = url.trim() && text.trim();

    return (
        <Box
            component="div"
            sx={{
                p: 2,
                border: '1px solid #e0e0e0',
                borderRadius: 1,
                backgroundColor: '#fafafa',
                mb: 1,
            }}
        >
            <TextField
                label={t('common.url', 'URL')}
                type="url"
                fullWidth
                size="small"
                value={url}
                onKeyDown={(e) => {
                    // disable Enter key to prevent form submission
                    if (e.key === 'Enter') {
                        handleSubmit(e);
                        e.preventDefault();
                    }
                }}
                onChange={(e) => setUrl(e.target.value)}
                placeholder="https://example.com"
                sx={{ mb: 2 }}
                autoFocus
            />
            <TextField
                label={t('common.text', 'Link text')}
                fullWidth
                size="small"
                value={text}
                onKeyDown={(e) => {
                    // disable Enter key to prevent form submission
                    if (e.key === 'Enter') {
                        handleSubmit(e);
                        e.preventDefault();
                    }
                }}
                onChange={(e) => setText(e.target.value)}
                placeholder={t('richtext.linkTextPlaceholder', 'Text to display')}
                sx={{ mb: 2 }}
            />
            <FormControlLabel
                control={
                    <Checkbox
                        checked={isButton}
                        onChange={(e) => setIsButton(e.target.checked)}
                        size="small"
                    />
                }
                label={t('richtext.displayAsButton', 'Display as button')}
                sx={{ mb: 1 }}
            />
            <Stack direction="row" spacing={1} justifyContent="flex-end">
                <Button onClick={onCancel} size="small">
                    {t('common.cancel', 'Cancel')}
                </Button>
                <Button onClick={handleSubmit} variant="contained" size="small" disabled={!isValid}>
                    {t('common.insert', 'Insert')}
                </Button>
            </Stack>
        </Box>
    );
};

export default InlineLinkInput;
